const { wlGlobalConfig } = window;
export const ENV = wlGlobalConfig.__environment;
export const SITE_URL = wlGlobalConfig.__site_url;
export const AJAX_URL =
  ENV === 'development' || ENV === 'review'
    ? `${SITE_URL}/wp/wp-admin/admin-ajax.php?action=`
    : `${SITE_URL}/wp-admin/admin-ajax.php?action=`;
export const UPLOADS_URL = wlGlobalConfig.__uploads_url;

let ALGOLIA_APP_ID = '';
let ALGOLIA_SEARCH_API_KEY = '';

if (typeof wlAlgolia !== 'undefined') {
  ALGOLIA_APP_ID = wlAlgolia.application_id;
  ALGOLIA_SEARCH_API_KEY = wlAlgolia.search_api_key;
}

export { ALGOLIA_APP_ID, ALGOLIA_SEARCH_API_KEY };
